export const cashReportOrderTypes = [
  { value: 11, label: '订货订单' },
  { value: 12, label: '积分订单' },
  { value: 13, label: '秒杀订单' },
  { value: 14, label: '换货订单' },
  { value: 2, label: '在线支付学费' },
  { value: 3, label: '在线支付充值' },
  { value: 4, label: '线下支付学费' },
  { value: 5, label: '线下支付充值' },
  { value: 6, label: '课程订单' },
  { value: 7, label: '会议订单' }
]

const fields = ['ordernum', 'type', 'nameorpho', 'levelId', 'state', 'payType',
  'ywName', 'areaName', 'customerstate', 'isOneselfDeveloped', 'timeType', 'startTime', 'endTime']

export function cashReportFilters(source) {
  const result = {}
  if (!source || typeof source !== 'object' || Array.isArray(source)) return result
  fields.forEach(key => {
    if (source[key] !== undefined && source[key] !== null && source[key] !== '') result[key] = source[key]
  })
  return result
}

export function cashReportExportRoute(query) {
  return { path: '/export/list', query: { code: 'OrderPerformanceExport', cashQuery: JSON.stringify(cashReportFilters(query)) } }
}

export function readCashReportRoute(raw) {
  if (typeof raw !== 'string') return {}
  try { return cashReportFilters(JSON.parse(raw)) } catch (error) { return {} }
}

export function cashPaymentLabel(value) {
  return ({ 0: '组合现金支付', 1: '支付宝', 2: '微信支付', 3: '支付凭证', 4: '银行卡' })[value] || '未记录'
}
